/*
* @desc 忘记密码
* @author caoyx
*/
import styles from './forgotPassword.scss';
import React, { PureComponent } from 'react';
import { Form, Icon, Input } from 'antd';
// import { Link } from 'react-router';
// import classNames from 'classnames';
import { hashHistory } from 'react-router';
import { EmailOrCellphoneCheck } from '../../utils/validator';

const FormItem = Form.Item;

class ForgotPassword extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        //
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                // const { userName } = values;
            }
        });
    };

    handleBack = () => {
        hashHistory.replace('/login');
    };

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <div className="not-login-bg">
                <div className="form-box">
                    <Form>
                        <FormItem>
                            {getFieldDecorator('userName', {
                                rules: [{ required: true, message: '请输入邮箱/手机号码！' }, EmailOrCellphoneCheck]
                            })(
                                <Input
                                    addonBefore={<Icon type="user" />}
                                    placeholder="请输入邮箱/手机号码"
                                    size="large"
                                />
                            )}
                        </FormItem>
                        <FormItem className={styles.verification}>
                            {getFieldDecorator('verification', {
                                rules: [{ required: true, message: '请输入获取到的验证码！', whitespace: true }]
                            })(
                                <Input
                                    addonBefore={<Icon type="lock" />}
                                    placeholder="请输入获取到的验证码"
                                    size="large"
                                />
                            )}
                            <button size="large" className="btn btn-primary">
                                获取验证码
                            </button>
                        </FormItem>
                        <FormItem>
                            {getFieldDecorator('password', {
                                rules: [{ required: true, message: '请输入新密码！', whitespace: true }]
                            })(
                                <Input
                                    addonBefore={<Icon type="lock" />}
                                    type="password"
                                    placeholder="请输入新密码"
                                    size="large"
                                />
                            )}
                        </FormItem>
                        <FormItem>
                            {getFieldDecorator('upassword', {
                                rules: [{ required: true, message: '请再次确认新密码！', whitespace: true }]
                            })(
                                <Input
                                    addonBefore={<Icon type="lock" />}
                                    type="password"
                                    placeholder="请再次确认新密码"
                                    size="large"
                                />
                            )}
                        </FormItem>
                        <FormItem>
                            <button size="large" onClick={this.handleSubmit} className="btn btn-primary">
                                确认提交
                            </button>
                        </FormItem>
                        <FormItem>
                            <button size="large" className="btn btn-primary" onClick={this.handleBack}>
                                返回登录
                            </button>
                        </FormItem>
                    </Form>
                </div>
            </div>
        );
    }
}

export default Form.create()(ForgotPassword);



// WEBPACK FOOTER //
// ./src/components/forgotPassword/ForgotPassword.jsx